/* eslint-disable prettier/prettier */
import { get } from '../axios'

// 人群行为条件列表
export function popupWindow_base_behaviorConditionList_get (map, option) {
  return get(
    `${process.env.VUE_APP_COMMONCONFIG}/popupWindow/base/behaviorConditionList`,
    map,
    option
  ).then(response => response)
}

// 生效页面列表
export function popupWindow_base_effectivePageList_get (map) {
  return get(
    `${process.env.VUE_APP_COMMON}/popupWindow/base/effectivePageList`,
    map
  )
}

// 弹窗样式列表
export function popupWindow_base_popupStyleList_get (map, option) {
  return get(
    `${process.env.VUE_APP_COMMONCONFIG}/popupWindow/base/popupStyleList`,
    map,
    option
  ).then(response => response)
}

// 弹窗类型列表
export function popupWindow_base_popupTypeList_get (map, option) {
  return get(
    `${process.env.VUE_APP_COMMONCONFIG}/popupWindow/base/popupTypeList`,
    map,
    option
  ).then(response => response)
}
